import React from "react";
import { Modal } from "antd";
import { SketchPicker } from "react-color";


const ColorPickerModal = ({ visible, onClose, color, onChange, title }) => {

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={title}
    >
      <SketchPicker
        color={color}
        onChange={c => onChange(c.hex)}
        presetColors={[
          "#ab322d",
          "#FCB900",
          "#7BDCB5",
          "#00D084",
          "#8ED1FC",
          "#0693E3",
          "#ABB8C3",
          "#EB144C",
          "#F78DA7",
          "#9900EF",
        ]}
      />
    </Modal>
  );
};

export default ColorPickerModal;
